import React, { useState, useEffect } from "react";
import centerOfMass from "@turf/center-of-mass";
import * as turf from "@turf/helpers";
import Map from "../Map/Map";
import SideMenu from "../SideMenu/SideMenu";
import DefaultDashboard from "../../Dashboard/DefaultDashboard";
import "./Dashboard.scss";
import { allBuildingsData } from "../../selectors/data";

import { defaultCenterPoint, zoomCampus } from "../../data/campusData";

import { connect, useSelector } from "react-redux";
import { fetchAccessPoints } from "../../actions/wifi";

import { getCoordinates } from "../../utils/GeoUtils";
import { isNotACampus } from "../../utils/EnvUtils";
import useUserCredentialsStore from "../../stores/useUserCredentialsStore";
import useSelectedAreaStore from "./stores/useSelectedAreaStore";
import useGeoJsonStore from "./stores/useGeoJsonStore";
import useTimeTypeStore from "./stores/useTimeTypeStore";
import useCurrentTabStore from "./stores/useCurrentTabStore";
import useIsMagnituteFilterOn from "../../hooks/useIsMagnituteFilterOn";

const Dashboard = ({ fetchAccessPoints, closed }) => {
  const isMagnituteFilterOn = useIsMagnituteFilterOn();

  const [centerPoint] = useState(defaultCenterPoint);
  const [reset, setReset] = useState(false);

  const area = useSelectedAreaStore(state => state.selectedArea);
  const setSelectedArea = useSelectedAreaStore(state => state.setSelectedArea);

  const authorizedGeoData = useGeoJsonStore(state => state.geoJson);
  const setAuthorizedGeoData = useGeoJsonStore(state => state.setGeoJson);

  const timeType = useTimeTypeStore(state => state.timeType);
  const setTimeType = useTimeTypeStore(state => state.setTimeType);

  const style = useCurrentTabStore(state => state.currentTab);
  const setStyle = useCurrentTabStore(state => state.setCurrentTab);

  const [selectedAlert, setSelectedAlert] = useState("");

  const [marker, setMarker] = useState([]);

  const loggedUser = useUserCredentialsStore(state => state.loggedUser);

  const [selectedAlertArea, setSelectedAlertArea] = useState({
    buildingId: "",
    name: ""
  });

  const [activeCategory, setActiveCategory] = useState("");

  let allBuildings = useSelector(allBuildingsData);

  const createMarkers = () => {
    setSelectedAlert("");
    let markers = isNotACampus ? [] : [...marker];

    authorizedGeoData.features.forEach(feature => {
      let center = centerOfMass(turf.polygon(getCoordinates(feature)));
      markers.push({
        lat: center.geometry.coordinates[1],
        lng: center.geometry.coordinates[0],
        properties: feature.properties
      });
    });

    setMarker(markers);
  };

  useEffect(() => {
    setSelectedAlertArea({
      buildingId: "",
      name: ""
    });
    fetchAccessPoints();
  }, [style]);

  useEffect(() => {
    createMarkers();
  }, [authorizedGeoData]);

  useEffect(() => {
    createMarkers();
  }, []);

  const [markersAllowed, setMarkersAllowed] = useState([]);
  const [filteredMarkersAllowed, setFilteredMarkersAllowed] = useState([]);

  useEffect(() => {
    setMarkersAllowed(
      marker.filter(m => !m.properties.isPrivate || loggedUser)
    );
  }, [marker]);

  useEffect(() => {
    setFilteredMarkersAllowed(markersAllowed);
  }, [markersAllowed]);

  useEffect(() => {
    if (selectedAlert) {
      authorizedGeoData.features.forEach(feature => {
        if (feature.properties.buildingId === selectedAlert) {
          setSelectedAlertArea(feature);
        }
      });
    } else {
      setSelectedAlertArea({
        buildingId: "",
        name: ""
      });
    }
  }, [selectedAlert]);

  return (
    <div className="dashboard-container">
      <SideMenu area={area} closed={closed} tab={style} setTab={setStyle}>
        <DefaultDashboard
          area={area}
          geoJson={authorizedGeoData}
          areas={authorizedGeoData.features}
          onSelectArea={setSelectedArea}
          onAlertClick={setSelectedAlert}
          setSelectedArea={setSelectedArea}
          setAuthorizedGeoData={setAuthorizedGeoData}
          setReset={setReset}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          timeType={timeType}
          setTimeType={setTimeType}
          markers={markersAllowed}
          filteredMarkers={filteredMarkersAllowed}
          setFilteredMarkers={setFilteredMarkersAllowed}
        ></DefaultDashboard>
      </SideMenu>
      <Map
        allAreasData={allBuildings}
        style={style}
        geoJson={authorizedGeoData}
        center={centerPoint}
        onPolygonClick={setSelectedArea}
        selectedAlertArea={selectedAlertArea}
        marker={marker}
        zoom={zoomCampus}
        reset={reset}
        setReset={setReset}
        area={area}
        timeType={timeType}
        filteredMarkersAllowed={filteredMarkersAllowed}
        isMagnituteFilterOn={isMagnituteFilterOn}
      ></Map>
    </div>
  );
};

export default connect(null, { fetchAccessPoints })(Dashboard);
